<template>
    <div class="base-recharge" :class="{'recharge-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="back-img" @click="$router.back()">
                <img src="~images/back.png" />
            </div>
            <div class="title">{{$route.query.name}}</div>
        </div>
        <div class="content">
            <div class="box" v-for="(item, index) in list" :key="index" @click="onList(index, item)">
                <div class="list">
                    <div class="left">
                        <div class="list-num">{{index + 1}}</div>
                        <div class="list-con">{{item.title}}</div>
                    </div>
                    <div class="right">
                        <img :class="{isimg: item.status == 1}" src="~images/down.png" />
                    </div>
                </div>
                <div class="details" id="el" :class="{isdetails: item.status == 1}">
                    <div v-for="(i, key) in item.list" :key="key">{{i}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseProblem',
        data () {
            return {
                list: []
            }
        },
        methods: {
            onList (index, item) {
                if (item.list.length > 0) {
                    this.list[index].status = this.list[index].status == 0 ? this.list[index].status = 1 : this.list[index].status = 0
                }
            }
        },
        created () {
            if (this.$route.query.name == '充值问题') {
                this.list = [
                    {
                        status: 0,
                        title: '游戏内充值未到账',
                        list: [
                            '1)检查账号是否登录有误，请确认登录账号与充值账号是否一致。',
                            '2)如果账号无误，这可能是由于网络延迟而造成的，请您耐心等待几分钟后，尝试重新登录游戏角色看看是否到账，如依然存在问题，可联系客服提供充值游戏账号和对应订单截图核实确认。（温馨提示：每笔订单支付间隔不能过短，低于一分钟的多笔订单可能存在充值异常导致无法到账。'
                        ]
                    },
                    {
                        status: 0,
                        title: '平台币充值未到账',
                        list: [
                            '如果您支付完成扣款成功，但没有增加相应的平台币，这可能是由于网络延迟而造成的，建议您稍后退出游戏平台重新登陆查看。如依然存在问题，可联系客服提供充值账号和对应订单截图核实确认。'
                        ]
                    },
                    {
                        status: 0,
                        title: '充值如何打折',
                        list: [
                            '1)	折扣游戏和部分H5游戏均为游戏内自动打折，充值时只需支付打折后的金额即可，如打折为5折，购买原价为1000元的道具只需支付500元。（提示：收到代充相关消息请慎重对待）',
                            '2)	BT游戏，游戏内直充即可，上线自带免费VIP和高比例充值福利，不支持折扣充值。'
                        ]
                    }
                ]
            } else if (this.$route.query.name == '返利问题') {
                this.list = [
                    {
                        status: 0,
                        title: '怎样才能获得返利',
                        list: [
                            '充值达到该游戏返利标准，在App内自主申请（仅支持BT游戏）或联系客服体系相关游戏信息，即可申请充值额外返利或道具（部分游戏为游戏内自动发送返利，此类游戏请勿重复提交），请尽量在充值后24小时内申请；大额充值玩家如有额外道具和装备需求，请联系客服确认后再充值！返利一般会在申请后24小时内发放，周末或节假日会稍有延迟；部分特殊道具也会延迟发放，无需担心！'
                        ]
                    },
                    {
                        status: 0,
                        title: '充值了，但是【返利申请】没有可以申请的东西',
                        list: [
                            '1)部分游戏只能通过人工申请，请联系在线客服申请您的返利',
                            '2)请查看您单日充值金额是否满足游戏返活活动要求大额充值，如有特殊返利或道具需求请直接联系客服'
                        ]
                    },
                    {
                        status: 0,
                        title: '返利到账形式有哪几种',
                        list: [
                            '1)发送到游戏内邮件中，请注意查收领取',
                            '2)直接发放到背包内，使用后获得奖励（如元宝卡、礼包等）',
                            '3激活码形式发放，一般是直接在APP中通知发放，您收到激活码后，直接在游戏内激活即可',
                            '4)在游戏内的某个【领奖】图标中领取',
                            '5)直接发放到角色，需要留意相关金额道具的变化'
                        ]
                    },
                    {
                        status: 0,
                        title: '返利多久会到',
                        list: [
                            '1)建议当天的返利申请，确定总金额后再提交申请，避免错过更高额的返还比例',
                            '2)返利的发放，一般是在一个工作日以内就会发放，节假日&周末部分游戏有延迟，到工作日后会尽量安排发放，无需担心',
                            '3)若延期还是确定自己没有收到返利，请及时联系客服进行核实返还情况。大额充值如有特殊返利或道具需求请直接联系客服'
                        ]
                    },
                    {
                        status: 0,
                        title: '怎么知道会返还多少元宝',
                        list: [
                            '返还元宝计算公式：充值金额*游戏充值比例*游戏返还比例举例：A游戏充值比例为1：500，你充值了100元，参与返还10%，那么应得的元宝数量：100*500*10=5000'
                        ]
                    },
                    {
                        status: 0,
                        title: '角色ID怎么查看',
                        list: [
                            '不同游戏的角色ID查看位置不同，但基本可归纳为：',
                            '1)点开头像可查看到角色ID',
                            '2)游戏内的系统-设置里，查找角色ID',
                            '3)如实在找不到可联系客服咨询'
                        ]
                    },
                    {
                        status: 0,
                        title: '道具奖励去哪里申领',
                        list: [
                            '有线下道具奖励返还的游戏，申请返利时，请一定备注您要的道具奖励，我们会为您提交；或联系在线客服进行咨询；大额充值如有特殊返利或道具需求请直接联系客服确认'
                        ]
                    },
                    {
                        status: 0,
                        title: '什么情况下，我的返利无法到账',
                        list: [
                            '1)请提供的返利申请信息错误，例如角色名错误，区服不对等，会导致无法发放。请您一定要保证你所提交的信息与您游戏内的信息时一致的；',
                            '2)刚刚申请了返利就改名了，这样的话，角色名就搜不到您的信息，因此会发送失败，或者发放给了别人'
                        ]
                    }
                ]
            } else if (this.$route.query.name == '会员问题') {
                this.list = [
                    {
                        status: 0,
                        title: '什么是焕游会员',
                        list: [
                            '焕游会员是由我们平台提供的用户特权服务系统。'
                        ]
                    },
                    {
                        status: 0,
                        title: '焕游会员分为那些等级',
                        list: [
                            '根据购买时长，我们讲焕游会员分为（一个月），（三个月）（六个月）（12个月）（终生）五个特权等级。'
                        ]
                    },
                    {
                        status: 0,
                        title: '焕游会员有什么好处',
                        list: [
                            '1)拥有独一无二的尊贵标识，',
                            '2)个人中心以及评论区专属会员标识，',
                            '3)签到及任务额外获得金币奖励等。'
                        ]
                    },
                    {
                        status: 0,
                        title: '如何成为焕游会员',
                        list: [
                            '通过焕游游戏App个人中心点击焕游会员卡进行购买可获得焕游会员特权。'
                        ]
                    },
                    {
                        status: 0,
                        title: '焕游会员购买时限可以叠加吗',
                        list: [
                            '重复购买相同等级的会员，焕游会员时间会增加，如果购买高等级会员，低等级会员剩余时间会被覆盖。'
                        ]
                    }
                ]
            } else if (this.$route.query.name == '货币问题') {
                this.list = [
                    {
                        status: 0,
                        title: '什么是平台币',
                        list: [
                            '平台币是由本平台提供的一种用于游戏支付的货币。'
                        ]
                    },
                    {
                        status: 0,
                        title: '平台币怎么获得',
                        list: [
                            '平台币可以通过平台内在线充值或角色交易获得。'
                        ]
                    },
                    {
                        status: 0,
                        title: '我的平台币如何消费到游戏',
                        list: [
                            '可以点击游戏中对应充值档位进行充值，支付方式选择使用平台币支付。'
                        ]
                    },
                    {
                        status: 0,
                        title: '平台币可以提现吗',
                        list: [
                            '目前暂时不支持平台币提现'
                        ]
                    },
                    {
                        status: 0,
                        title: '什么是金币',
                        list: [
                            '金币是由我们平台免费提供的一种用于游戏支付和兑换代金券的货币。'
                        ]
                    },
                    {
                        status: 0,
                        title: '金币的获取途径是什么',
                        list: [
                            '1)每日签到；',
                            '2)游戏评价；',
                            '3)任务中心；',
                            '4)邀请好友等多种方式获得。'
                        ]
                    }
                ]
            } else if (this.$route.query.name == '交易问题') {
                this.list = [
                    {
                        status: 0,
                        title: '什么是小号',
                        list: [
                            '平台的小号系统可以用来交易角色，一个大号可以创建多个小号，小号之间互相独立。需要卖出角色时，只需要选择角色对应的小号即可，不影响账号本身和其它小号的使用。'
                        ]
                    },
                    {
                        status: 0,
                        title: '怎样买号',
                        list: [
                            '买卖账号都需要在App内的交易菜单中进行，购买小号需要登录您的账号，购买后小号会直接转移到您的账号下。用您的账号进入游戏后，会在您的账号下自动增加一个所购买的小号，使用该小号可以直接登陆即可。'
                        ]
                    },
                    {
                        status: 0,
                        title: '怎样卖号',
                        list: [
                            '1)点击交易界面的“我要卖号”',
                            '2)选择需要出售小号对应的游戏',
                            '3)选择小号（同一个游戏可能存在多个小号，请务必选择正确的小号）',
                            '4)填写标题、描述、区服、价格，以及上传截图，为了顺利通过审核，标题和描述中请不要带有联系方式等，提交的截图也需要注意不要带有广告信息以及无关截图',
                            '5)成功提交审核后，管理员会在一个工作内日处理'
                        ]
                    },
                    {
                        status: 0,
                        title: '买号安全吗',
                        list: [
                            '交易系统出售的是玩家主账号下的单个小号，买家购买成功之后，该小号就会转移到买家的账号里，这个过程不需要从买家那里获取账号密码，是非常安全的，而且卖家也无法找回。'
                        ]
                    },
                    {
                        status: 0,
                        title: '提交卖号后，我的号怎么登录不上去了',
                        list: [
                            '提交出售之后，小号会从您的账号里移出，是不能再次登录的哦~',
                            '如需登录游戏，请先取消出售，但下次出售仍需重新提交审核'
                        ]
                    }
                ]
            } else if (this.$route.query.name == '游戏问题') {
                this.list = [
                    {
                        status: 0,
                        title: 'IOS设备打开游戏时提示无法验证',
                        list: [
                            '如果游戏打开时出现闪退并提示“未受信任”，请等待平台修复重新下载游戏即可。'
                        ]
                    },
                    {
                        status: 0,
                        title: 'IOS设备安装游戏一直显示等待中，不自动安装',
                        list: [
                            'IOS设备默认100M大小以上的游戏或软件只能通过wifi下载，如您是移动网络，请连接wifi后下载即可。如无wifi请无点击安装，待桌面出现安装图标后，关闭蜂窝数据，重启手机，然后打开蜂窝数据即可下载！'
                        ]
                    },
                    {
                        status: 0,
                        title: 'IOS设备下载时提示此时无法下载',
                        list: [
                            '提示“此时无法下载”可能由于网络原因出现短时间内反复安装不上的情况，请确保网络稳定，或重启手机后再次进行尝试。'
                        ]
                    },
                    {
                        status: 0,
                        title: '线下交易问题',
                        list: [
                            '1)官方不支持任何形式的线下交易，包括游戏账号、游戏货币、游戏道具等。',
                            '2)请保护个人账号信息，凡是线下交易、账号共享导致的账号纠纷问题，官方不予处理，线下交易、账号纠纷等产生的纠纷，没有明确的交易流程，且聊天记录、转账截图等均可伪造，基本无法确定事实真伪，从本质上而言，账号共享，线下交易本身就算对自己个人账号财产的不负责。'
                        ]
                    },
                    {
                        status: 0,
                        title: '游戏内被封号',
                        list: [
                            '1)在游戏内利用游戏BUG，游戏外挂，游戏漏洞等非法获益，游戏商会进行永久封号，不予处理。',
                            '2)游戏内辱骂他人，宣传折扣信息，发布QQ群、QQ号、微信号等信息影响游戏环境，会视情节严重程度进行封号处罚。'
                        ]
                    }
                ]
            } else {
                this.list = [
                    {
                        status: 0,
                        title: '忘记账号',
                        list: [
                            '1)焕游游戏平台可以使用【用户名】或【手机号码】进行登陆，如果忘记用户名，可以通过手机号码登陆后，进入个人中心查看用户名；',
                            '2)手机号码与账号全部忘记的情况下，可以向客服提供身份证证件号协助查询；',
                            '3)在个人中心如果有绑定第三方登陆，可以直接使用第三方登陆后，进入个人中心查看用户名。'
                        ]
                    },
                    {
                        status: 0,
                        title: '账号被盗',
                        list: [
                            '1)如果账号被盗或者被骗，请尽快登陆焕游游戏客户端，在我的>个人中心>修改密码，按照提示修改密码。',
                            '2)若密码已经被修改，可以通过忘记密码找回。'
                        ]
                    },
                    {
                        status: 0,
                        title: '忘记密码',
                        list: [
                            '1)【手机号码-号码可用】，可以通过忘记密码选项自助进行找回修改密码；',
                            '2)【手机号码-号码不可用】，可向客服提供手机号码或账号、支付宝、微信支付方式的历史支付记录截图，核实找回。'
                        ]
                    },
                    {
                        status: 0,
                        title: '账号的密码如何修改',
                        list: [
                            '我的>个人中心>修改密码，按照提示修改即可'
                        ]
                    },
                    {
                        status: 0,
                        title: '如何绑定手机号',
                        list: [
                            '焕游游戏平台需要用户使用手机号码注册，注册号码即为绑定的手机号码。'
                        ]
                    },
                    {
                        status: 0,
                        title: '如何换绑手机号',
                        list: [
                            '我的>个人中心>手机号>手机解绑>手机绑定'
                        ]
                    },
                    {
                        status: 0,
                        title: '如何绑定第三方登陆',
                        list: [
                            '我的>个人中心>第三方绑定中选择相对应的第三方，按照提示进行绑定。'
                        ]
                    },
                    {
                        status: 0,
                        title: '如何实名验证',
                        list: [
                            '我的>个人中心>实名认证，按照提示填写即可'
                        ]
                    },
                    {
                        status: 0,
                        title: '无法实名认证怎么办',
                        list: [
                            '请联系客服提供无法实名验证的提示截图，保证您验证的信息没有填写错误，如果还是没法验证，请您提供您的身份证原件照片以及相应账号信息提供客服核实查看。'
                        ]
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-recharge {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 72px;
                    height: 72px;
                }
            }
            .title {
                font-size: 51px;
                text-align: center;
            }
        }
        .content {
            flex: 1;
            overflow-y: scroll;
            padding: 0 60px;
        }
        .box {
            overflow: hidden;
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        }
        .box:last-child {
            margin-bottom: 60px;
        }
        .list {
            padding: 51px 0;
            display: flex;
            justify-content: space-between;
            .left {
                height: 100%;
                font-size: 38px;
                flex: 1;
                display: flex;
                align-items: center;
            }
            .list-num {
                width: 48px;
                height: 48px;
                font-size: 30px;
                border-radius: 6px;
                background: $color;
                margin-right: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .list-con {
                flex: 1;
            }
            .right {
                width: 30px;
                display: flex;
                align-items: center;
                img {
                    width: 30px;
                    height: 30px;
                    transition: all 0.3s;
                }
                .isimg {
                    transform: rotate(180deg);
                }
            }
        }
        .details {
            height: 0;
            color: rgba(255, 255, 255, 0.5);
            font-size: 36px;
            padding: 0 0 0 88px;
            overflow: hidden;
            transition: all 0.3s linear;
        }
        .isdetails {
            height: auto;
            padding: 0 0 50px 88px;
        }
    }
    // 竖屏css
    .recharge-sp {
        width: 100%;
        height: 100%;
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;
            .back-img {
                width: 290px;
                height: 240px;
                img {
                    width: 130px;
                    height: 130px;
                }
            }
            .title {
                font-size: 92px;
            }
        }
        .content {
            padding: 0 90px;
        }
        .box:last-child {
            margin-bottom: 90px;
        }
        .list {
            padding: 92px 0;
            .left {
                font-size: 70px;
            }
            .list-num {
                width: 87px;
                height: 87px;
                font-size: 54px;
                border-radius: 10px;
                margin-right: 60px;
            }
            .right {
                width: 54px;
                img {
                    width: 54px;
                    height: 54px;
                }
            }
        }
        .details {
            font-size: 65px;
            padding: 0 0 0 150px;
        }
        .isdetails {
            padding: 0 0 90px 150px;
        }
    }
</style>